











































import { Component, Prop, Vue } from 'vue-property-decorator';    
import axios from "axios";
import { General } from "@/services/General";

@Component({
    name: 'AddDropDown'
})
export default class AddDropDown extends Vue {
    @Prop({
        type: String,
        required: true
    })
    dropDownItemSource: string;

   

    loading: boolean = false;
    newDropDownItem: string = "";
    otherErrors: string = "";
    clickButton: boolean = false;

    showAddDropDownModal() {
        this.resetFields();
        this.$bvModal.show(this.modalId);
    }
    hideAddDropDownModal() {
    
        this.$bvModal.hide(this.modalId);
    }
    async addNewDropDownItem(){
        this.clickButton = true;
        if (this.newDropDownItem==""){
            return;
        }
        this.loading = true;

        try {
            var results = await axios({
                method: "post",
                url: General.GetApiUrl("/api/dropDownItem/AddDropDownItem"),
                data: {
                    ItemText: this.newDropDownItem,
                    CodDropDownSource: this.dropDownItemSource,
                    IdDropDownFather:null,
                },
                withCredentials: true,
                responseType: "json",
            });
            let newid = results.data.idDropDownItem;
            
            General.showAlertSuccess("Item successfully added", this);
                this.hideAddDropDownModal();
                this.emitInsertItemDone(newid);
            
        } catch (error) {
            let status = error.response.data.status; 

            switch(status){
                case 406:                    
                    this.otherErrors = "This item is already present!";
                    break;
                default:
                    General.HandleError(error, this);

            }
            
        } finally {
            this.loading = false;
            
        }


    }
    emitInsertItemDone(newid:string): void {
        this.$emit("insert-item-done", {
            id: newid,
            dropDownItem: this.newDropDownItem,
            dropDownSource: this.dropDownItemSource
        })
    }
    mounted() {
        this.resetFields();
       


    }

    get modalId():string{
        return (this as any)._uid + "-add-dropDown-modal";
        

    }

    resetFields(){
        this.loading = false;
        this.newDropDownItem = "";
        this.clickButton = false;
    }

    returnState(condition: boolean): boolean {
        if (this.clickButton){
            if (this.otherErrors!="") return false;
            return condition;
        }else{
            return null;
        }
    }
}
